module.exports = {"full":{"All-instruments":"所有乐器","No-guitar":"没有吉他"},"details":{"Lesson-Details":"课程详情","Tablature":"包括"}};